import { queryOptions } from '@tanstack/react-query';

import {
  getProductsAndServicesQuery,
  getProductServiceQuery,
} from '../settings/products-and-services-templates/shared/product-and-service-apis';

export const getProductServiceQueryOptions = (id: string) => queryOptions(getProductServiceQuery(id));
export const getProductsAndServicesQueryOptions = () => queryOptions(getProductsAndServicesQuery());
